import React, { useState } from "react";
import { Card, CardTitle, Row, CardSubtitle, Button, Col } from "reactstrap";
import { UploadDocument, UploadLink } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import AddLinkModal from "../Modal/AddLinkModal";
import AddDocumentsModal from "../Modal/AddDocumentModal";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";

export default function DocumentPlaceHolder(props) {
  const intl = useIntl();
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const mutateUploadDocument = useMutation({ mutationFn: UploadDocument });
  const mutateUploadLink = useMutation({ mutationFn: UploadLink });
  const queryClient = useQueryClient();

  const toggleLinkModal = () => {
    setLinkModalOpen((prevState) => !prevState);
  };

  const toggleDocumentModal = () => {
    setDocumentModalOpen((prevState) => !prevState);
  };

  const handleUploadLink = (coursesAndModules, link) => {
    let courseModuleIds = "";
    if (coursesAndModules.modules.length > 0) {
      coursesAndModules.modules.forEach((mod) => {
        courseModuleIds += "&forTheseModules=" + mod;
      });
    }
    let values = {
      link: link,
      classId: props.classId,
      courseId: coursesAndModules.courses,
      teacherId: props.teacherInfo.data.id,
      moduleids: courseModuleIds,
    };
    mutateUploadLink.mutate(
      {
        values,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            queryClient.invalidateQueries({ queryKey: ["FetchCoursesByClassId"] });
            toast.success(intl.formatMessage({ id: "LinkUploaded" }));
          } else {
            toast.warn(data);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data);
        },
      }
    );
  };

  const handleUploadDocument = (coursesAndModules, file) => {
    let courseModuleIds = "";
    if (coursesAndModules.modules.length > 0) {
      coursesAndModules.modules.forEach((mod) => {
        courseModuleIds += "&forTheseModules=" + mod;
      });
    }

    let fileName = file.name.toLowerCase();
    fileName = fileName.replace("ä", "a").replace("å", "a").replace("ö", "o");

    let values = {
      file: file,
      fileName: fileName,
      classId: props.classId,
      courseId: coursesAndModules.courses,
      teacherId: props.teacherInfo.data.id,
      moduleids: courseModuleIds,
    };

    mutateUploadDocument.mutate(
      {
        values,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            queryClient.invalidateQueries({ queryKey: ["FetchCoursesByClassId"] });
            toast.success("Dokumentet har laddats upp");
          } else {
            toast.warn(data);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data);
        },
      }
    );
  };

  return (
    <>
      <Row style={{ justifyContent: "space-evenly" }}>
        <Col lg={6}>
          <Card body>
            <CardTitle>
              <FormattedMessage id="Documents" />
              <hr />
            </CardTitle>
            <CardSubtitle>
              <FormattedMessage id="UploadDocumentText" />
            </CardSubtitle>
            <Row>
              <Col lg={6}>
                <Button
                  onClick={toggleDocumentModal}
                  color="primary"
                  outline
                  className="mt-2 p-1"
                >
                  <FormattedMessage id="UploadDocument" />
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={6}>
          <Card body>
            <CardTitle>
              <FormattedMessage id="Link" />
              <hr />
            </CardTitle>
            <CardSubtitle>
              <FormattedMessage id="AddLinkText" />
            </CardSubtitle>
            <Row>
              <Col lg={4}>
                <Button
                  onClick={toggleLinkModal}
                  color="primary"
                  outline
                  className="mt-2 p-1"
                >
                  <FormattedMessage id="AddLink" />
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <AddLinkModal
        linkModalOpen={linkModalOpen}
        toggleLinkModal={toggleLinkModal}
        courses={props.coursesData.data}
        handleUploadLink={handleUploadLink}
      />
      <AddDocumentsModal
        documentModalOpen={documentModalOpen}
        toggleDocumentModal={toggleDocumentModal}
        courses={props.coursesData.data}
        handleUploadDocument={handleUploadDocument}
      />
    </>
  );
}
